export default {
	diagnostics: {
		// Keyed by the generator's stable diagnostic `code`, never by its message text — the
		// server's own wording is the fallback for a code this client does not know yet.
		manualCodeName:
			"This code name was set by hand. Renaming the term will no longer rename it.",
	},
};
